import Vue from 'vue';
import VueRouter from 'vue-router';
//import Dashboard from '../views/Dashboard.vue';
import PageNotFound from '../views/PageNotFound.vue';
import AppState from '../store/App.js';
//import { authGuard } from '../auth/authGuard';
//import { getInstance } from './index';

Vue.use(VueRouter);
/*
function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`);
}
*/
const routes = [
  {
    path: '/',
    redirect: '/settings/project'
  },
  {
    path: '/home',
    redirect: '/settings/project'
  },
  /*{
    path: '/home',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: authGuard,
    meta: {
      requiredRole: 'User' // A protected route
    }
  },*/
  /*{
    path: '/projects',
    name: 'Projekte',
    component: () => import( '../views/Projects.vue')
  },*/

  {
    path: '/reports',
    component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "reports" */ '../components/ReportsTabControlling.vue'),
        name: 'Berichte Kosten'
      },
      {
        path: 'orders',
        name: 'Berichte Aufträge',
        component: () => import(/* webpackChunkName: "reports" */ '../components/ReportsTabOrders.vue')
      },
      {
        path: 'invoices',
        name: 'Berichte Rechnungen',
        component: () => import(/* webpackChunkName: "reports" */ '../components/ReportsTabInvoices.vue')
      }
    ]
  },
  {
    path: '/controlling',
    name: 'Kostencontrolling',
    component: () => import(/* webpackChunkName: "controlling" */ '../views/Controlling.vue')
  },
  {
    path: '/budget/kke',
    name: 'Budgetierung',
    component: () => import(/* webpackChunkName: "controlling" */ '../views/BudgetKke.vue'),
    beforeEnter: (to, from, next) => {
      localStorage.setItem('budgetTab', 'kke');
      next();
    }
  },

  {
    path: '/budget/:id',
    component: () =>
      import(/* webpackChunkName: "budget" */ /* webpackPrefetch: true */ '../views/BudgetCostGroupDetail.vue'),

    children: [
      {
        path: '',
        alias: 'budget',
        name: 'KKE Budget',
        component: () =>
          import(
            /* webpackChunkName: "budget" */ /* webpackPrefetch: true */ '../components/budget/BudgetCostGroupDetailsAllocations.vue'
          )
      }
    ]
  },
  {
    path: '/budget',
    redirect: '/budget/kke'
  },
  {
    path: '/allocationunits/:id',
    component: () => import(/* webpackChunkName: "allocationunits" */ '../views/AllocationUnitDetails.vue'),
    children: [
      {
        path: '',
        alias: 'budget',
        name: 'VE Budget',
        component: () => import(/* webpackChunkName: "allocationunits" */ '../views/AllocationUnitDetailsBudget.vue')
      },
      {
        path: 'orders',
        name: 'VE Aufträge',
        component: () => import(/* webpackChunkName: "allocationunits" */ '../views/AllocationUnitDetailsOrders.vue')
      },
      {
        path: 'invoices',
        name: 'VE Rechnungen',
        component: () => import(/* webpackChunkName: "allocationunits" */ '../views/AllocationUnitDetailsInvoices.vue')
      }
    ]
  },
  {
    path: '/allocationunits',
    name: 'Vergabeeinheiten',

    component: () =>
      import(/* webpackChunkName: "allocationunits" */ /* webpackPrefetch: true */ '../views/AllocationUnits.vue')
  },
  {
    path: '/changemanagement',
    name: 'Änderungsmanagement',
    component: () => import(/* webpackChunkName: "orders" */ '../views/BudgetPat.vue'),
    children: []
  },
  {
    path: '/changemanagement/:id/print',
    name: 'Planänderung drucken',
    component: () => import(/* webpackChunkName: "patprint" */ '../views/BudgetPatPrintSheet.vue')
  },
  {
    path: '/changemanagement/create',
    name: 'Planänderung erstellen',
    component: () => import(/* webpackChunkName: "patcreate" */ '../views/BudgetPatCreate.vue')
  },
  {
    path: '/changemanagement/:id',
    name: 'Planänderung bearbeiten',
    component: () => import(/* webpackChunkName: "patcreate" */ '../views/BudgetPatCreate.vue')
  },
  {
    path: '/preiserfassung',
    name: 'Preiserfassung',

    component: () => import(/* webpackChunkName: "preiserfassung" */ '../views/Preiserfassung.vue')
  },
  {
    path: '/preiserfassung/create',
    //alias: 'budget',
    name: 'VEa',
    component: () => import(/* webpackChunkName: "preiscreate" */ '../views/PreiserfassungDetail.vue')
  },
  {
    path: '/preiserfassung/:id',
    //alias: 'budget',
    name: 'VEb',
    component: () => import(/* webpackChunkName: "preiscreate" */ '../views/PreiserfassungDetail.vue')
  },
  {
    path: '/orders',
    name: 'Aufträge & Nachträge',

    component: () => import(/* webpackChunkName: "orders" */ '../views/Orders.vue')
  },
  {
    path: '/orders/create',
    name: 'Erstellen',

    component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersForm.vue')
  },
  {
    path: '/orders/:id',
    //name: 'Auftrag',
    //component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersForm.vue')
    component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersAddendums.vue'),
    children: [
      {
        path: '/',
        name: 'Auftrag',
        component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersForm.vue')
      },
      {
        path: 'view',
        name: 'Hauptauftrag',

        component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersForm.vue')
      },
      {
        path: 'addendums/create',
        component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersAddendumForm.vue'),
        name: 'Nachtrag erfassen'
      },
      {
        path: 'addendums/:aid',
        name: 'Nachtrag anzeigen',
        component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersAddendumForm.vue')
      },
      {
        path: 'addendums',
        name: 'Nachträge',
        component: () => import(/* webpackChunkName: "orders" */ '../views/OrdersAddendumTable.vue')
      }
    ]
  },

  {
    path: '/invoices/:id/create',
    name: 'Beleg erfassen',

    component: () => import(/* webpackChunkName: "invoices" */ '../views/InvoicesForm.vue')
  },
  {
    path: '/invoices/:id/:iid',
    name: 'Rechnungsdetails',

    component: () => import(/* webpackChunkName: "invoices" */ '../views/InvoicesForm.vue')
  },
  {
    path: '/invoices/all',
    name: 'Alle Belege',

    component: () => import(/* webpackChunkName: "invoicecreate" */ '../views/InvoicesAll.vue')
  },
  {
    path: '/invoices/create',
    name: 'Rechnung erstellen',

    component: () => import(/* webpackChunkName: "invoicecreate" */ '../views/InvoicesForm.vue')
  },
  {
    path: '/invoices/:id',
    name: 'Rechnungsübersicht',

    component: () => import(/* webpackChunkName: "invoices" */ '../views/InvoicesDetailList.vue')
  },
  {
    path: '/invoices',
    name: 'Rechnungen',

    component: () => import(/* webpackChunkName: "invoices" */ '../views/InvoicesVE.vue')
  },
  {
    name: 'Rechnungsbegleitblatt',
    path: '/invoicesheet/:id/:iid',
    component: () => import(/* webpackChunkName: "invoiceSheet" */ '../views/InvoiceSheet.vue')
  },
  {
    path: '/risks',
    //name: 'Risikobewertung',
    //redirect: '/risks/allocationunits',
    component: () => import(/* webpackChunkName: "risks" */ '../views/Risks.vue'),
    beforeEnter: (to, from, next) => {
      const lastItem = localStorage.getItem('risksTab');
      if (to.path == '/risks' || to.path == '/risks/') {
        if (lastItem) {
          return next('/risks/' + lastItem);
        } else {
          localStorage.setItem('risksTab', 'allocationunits');
          return next('/risks/allocationunits');
        }
      } else {
        return next();
      }
    },
    children: [
      {
        path: 'allocationunits/:id/:rid',
        name: 'Chancen & Risiken Formular',
        meta: {
          title: 'Risiko'
        },
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksForm.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'allocationunits');
          next();
        }
      },
      {
        path: 'allocationunits/create',
        name: 'Chancen & Risiken ohne VE',
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksForm.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'allocationunits');
          next();
        }
      },
      {
        path: 'allocationunits/:id',
        name: 'Chancen & Risiken Details',
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksVEList.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'allocationunits');
          next();
        }
      },
      {
        path: 'allocationunits',
        name: 'Chancen & Risiken',
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksVE.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'allocationunits');
          next();
        }
      },
      {
        path: 'project/:rid',
        name: 'Chancen & Risiken Project Formular',
        meta: {
          title: 'Projektrisiko'
        },
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksForm.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'allocationunits');
          next();
        }
      },
      {
        path: 'project',
        name: 'Chancen & Risiken Projekt',
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksProject.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('risksTab', 'project');
          next();
        }
      },
      {
        path: ':rid',
        name: 'Chancen & Risiken Projekt Formular',
        meta: {
          title: 'Risiko'
        },
        component: () => import(/* webpackChunkName: "risks" */ '../views/RisksForm.vue')
      }
    ]
  },
  {
    path: '/abnahmen',
    name: 'Abnahmen',

    component: () => import(/* webpackChunkName: "abnahmen" */ '../views/Abnahmen.vue')
  },
  {
    path: '/nachkalkulation',
    name: 'Nachkalkulation',

    component: () => import(/* webpackChunkName: "nachkalkulation" */ '../views/Nachkalkulation.vue')
  },
  {
    path: '/cashflow',
    name: 'Mittelabfluss',

    component: () => import(/* webpackChunkName: "cashflow" */ '../views/CashFlow.vue')
  },
  {
    path: '/completion',
    name: 'Projektabschluss',
    component: () => import(/* webpackChunkName: "completion" */ '../views/Completion.vue')
  },
  {
    path: '/completion/end',
    name: 'Projekt beendet',
    component: () => import(/* webpackChunkName: "completion" */ '../views/CompletionMessage.vue')
  },
  {
    path: '/profile',
    name: 'Mein Profil',
    component: () => import(/* webpackChunkName: "profile" */ '../views/MyProfile.vue')
  },
  {
    path: '/settings',
    redirect: '/settings/project',
    beforeEnter: (to, from, next) => {
      const lastItem = localStorage.getItem('projectTab');
      console.log('Zzz lastItem', lastItem, to.path);
      if (lastItem && '/settings/' + lastItem != to.path) {
        next('/settings/' + lastItem);
      } else {
        next();
      }
    },
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    children: [
      {
        path: 'project',
        name: 'Projekteinstellungen',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/ProjectSettings.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'project');
          next();
        }
      },

      {
        path: 'general',
        name: 'Allgm. Einstellungen',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'general');
          next();
        }
      },
      {
        path: 'customattributes',
        name: 'Benutzerdefiniterte Felder',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/CustomAttributes.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'customattributes');
          next();
        }
      },
      {
        path: 'pat',
        name: 'PÄT Einstellungen',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/PAT.vue'),
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'pat');
          next();
        }
      },

      {
        path: 'useradmin',
        name: 'Benutzerverwaltung',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/UserAdmin.vue'),
        meta: {
          requiredRole: 'Admin' // A protected route
        },
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'useradmin');
          next();
        }
      },
      {
        path: 'customeradmin',
        name: 'Kundenverwaltung',
        component: () => import(/* webpackChunkName: "settings" */ '../components/settings/CustomerAdmin.vue'),
        meta: {
          requiredRole: 'Admin' // A protected route
        },
        beforeEnter: (to, from, next) => {
          localStorage.setItem('projectTab', 'customeradmin');
          next();
        }
      }
    ]
  },
  {
    path: '/playground',
    name: 'Playground',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "playground" */ '../views/Playground.vue')
  },
  { path: '*', component: PageNotFound }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  linkExactActiveClass: 'active',
  routes
});

router.beforeEach((to, from, next) => {
  if (window.innerWidth < 1000) {
    AppState.showNav = false;
  } else {
    AppState.showNav = true;
  }
  // hack workaround, frag nict
  // navigation wird abgebrochen, wenn man bereits im risiko menü und und nochmal auf das menü item geklickt hat.
  // ansonsten hätte er den redirect zur risisk unterroute nicht ausgeführt und versucht die /risks route auszuführen.
  if (to.path == '/risks' && from.path.startsWith('/risks')) return next('/risks/' + localStorage.getItem('risksTab'));

  document.title = (to.meta.title || to.name) + ' - ' + process.env.VUE_APP_NAME;

  //setTimeout(() => {  // hier braucht es einen Tri-State: 0,1,2 -> isLoading=0 wird hier gesetzt und in der Funktion isLoading auf =3 geprüft, und falls nicht =3, dann isLoading=2. in den einzelnen Komponenten wird dann auf =2 geprüft

  AppState.isLoading = true;
  //}, 150);

  next();
});

export default router;
